__turbopack_context__.v({
  "component": "style-module-scss-module__0kNJyq__component",
  "icon": "style-module-scss-module__0kNJyq__icon",
});
